import { createSelector } from 'reselect'

export const getActiveTab = createSelector(
  state => state && state.ads && state.ads.add && state.ads.add.activeTab ? state.ads.add.activeTab : null,
  tab => tab
)
